import { render, staticRenderFns } from "./courtNotice.vue?vue&type=template&id=6559aa3a&scoped=true&"
import script from "./courtNotice.vue?vue&type=script&lang=js&"
export * from "./courtNotice.vue?vue&type=script&lang=js&"
import style0 from "./courtNotice.vue?vue&type=style&index=0&id=6559aa3a&prod&scoped=true&lang=css&"
import style1 from "./courtNotice.vue?vue&type=style&index=1&id=6559aa3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559aa3a",
  null
  
)

export default component.exports